import { CSSProperties } from "react";

export const styles = {
    fileInput: {
        display: "none",
    } as CSSProperties,
};
